import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import dotProductCommons from './commons/dot_product.js'

const level = new Level({
    name: 'dot_product_with_ortho_unit',
    dependencies: [
        'levels_maths/vector'
    ]
})


function common (q, params) {

    let vectors = dotProductCommons.vectors(params)

    dotProductCommons.displayVectors(q, vectors)


    if (!params.noCoordsInQuestion) {
        dotProductCommons.displayCoords(q, vectors)
    }

    dotProductCommons.question(q, vectors)
}


level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: 1,
            uY: 0,
            vX: random.fairChoiceInt(2, 7, {name: 'vx'}),
            vY: random.fairChoiceInt(1, 5, {name: 'vy'}),
            noCoordsInQuestion: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: 1,
            uY: 0,
            vX: random.fairChoiceInt(2, 7, {name: 'vx'}),
            vY: -random.fairChoiceInt(1, 5, {name: 'vy'}),
            invertLabels: true,
            noCoordsInQuestion: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: 1,
            uY: 0,
            vX: -random.fairChoiceInt(2, 7, {name: 'vx'}),
            vY: random.fairChoiceInt(1, 5, {name: 'vy'}),
            noCoordsInQuestion: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: 0,
            uY: 1,
            vX: random.fairChoiceInt(2, 5, {name: 'vx'}),
            vY: random.fairChoiceInt(2, 7, {name: 'vy'}),
            invertLabels: true,
            noCoordsInQuestion: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: 0,
            uY: 1,
            vX: -random.fairChoiceInt(2, 5, {name: 'vx'}),
            vY: -random.fairChoiceInt(2, 7, {name: 'vy'}),
            invertLabels: true
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            uX: -1,
            uY: 0,
            vX: random.fairChoiceInt(2, 7, {name: 'vx'}),
            vY: random.fairChoiceInt(1, 5, {name: 'vy'})
        })
    }
})



export default level

